import React, { Component } from 'react'

import First from '../block/First'
import KatalogNg from '../block/KatalogNg'
import EastDragon from '../block/EastDragon'
import About from '../block/About'
import History from '../block/History'
import Postavki from '../block/Postavki'
import Stati from '../block/Stati'
import Faq from '../block/Faq'

class App extends Component {

  render() {

    const data = this.props?.data

    return (
      <>
        <First data={data} />
        <KatalogNg data={data} />
        <EastDragon data={data} />
        <About data={data} />
        <History data={data} />
        <Postavki data={data} />
        <Stati data={data} />
        <Faq data={data} />
      </>
    )
  }
}

export default App